<script lang="ts">
  import { animationsConfig } from "./config/animations";
  import MobileAnimation from "./components/MobileAnimation.svelte";
  import {
    mobileActivityIndex,
    selectedActivityIndex,
    urlParams,
    isOtherActivitiesWindowOpen,
    selectedOtherActivity,
    assetsLoaded,
    assetsProgress,
  } from "./store/AppState";
  import MobileControls from "./components/MobileControls.svelte";
  import MobileActivityBadge from "./components/MobileActivityBadge.svelte";
  import ModalWindow from "./components/ModalWindow.svelte";
  import OtherActivitiesWindow from "./components/OtherActivitiesWindow.svelte";
  import { afterUpdate } from "svelte";
  import { giftsConfig } from "./config/gifts";

  $: allLoaded =
    animationsLoaded &&
    (giftsLoaded || (window.isClosed && !window.isShowroom));
  let animationsLoaded = false;
  let giftsLoaded = false;

  $: loadedCounter = 0;

  const handleAnimationLoad = () => {
    loadedCounter++;
    $assetsProgress += 1;
    if (loadedCounter >= animationsConfig.length * 2) {
      animationsLoaded = true;
    }
  };

  const handleGiftsLoad = () => {
    giftsLoaded = true;
  };

  afterUpdate(() => {
    if (allLoaded) {
      $assetsLoaded = true;
    }
  });
</script>

<div
  style={`min-height: ${
    __MODE__ === "production" ? "calc(100dvh - 6.4rem)" : "100vh"
  }`}
>
  <div
    class="animation-container"
    style={`height: ${
      __MODE__ === "production" ? "calc(100dvh - 6.4rem)" : "100vh"
    }; visibility: ${allLoaded ? "visible" : "hidden"}`}
  >
    {#each animationsConfig.toSorted((a, b) => a.order - b.order) as config}
      <MobileAnimation
        {config}
        index={$mobileActivityIndex}
        onLoad={handleAnimationLoad}
        {allLoaded}
      />
    {/each}
    <MobileControls onLoad={handleGiftsLoad} />
  </div>
</div>
{#if $selectedActivityIndex !== null}
  <MobileActivityBadge handleClose={() => ($selectedActivityIndex = null)} />
{/if}
{#if $urlParams.has("aktivita") && $selectedActivityIndex !== null}
  {#if giftsConfig[$selectedActivityIndex].type !== "game" || ["vanoce-a-pohadky-v-az-kvizu", "pohlednice", "tvorivy-duch-vanoc"].includes(giftsConfig[$selectedActivityIndex].slug)}
    <ModalWindow />
  {/if}
{/if}
{#if ($urlParams.has("aktivita") && $selectedOtherActivity !== null) || $isOtherActivitiesWindowOpen}
  <OtherActivitiesWindow />
{/if}

<style>
  .animation-container {
    position: absolute;
    background: #d8f9ff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    width: 100%;
    visibility: hidden;
  }
</style>
